import { injectable } from "inversify";
import type { CallbackSubscription } from "../../engine/Utilities/CallbackManager";
import { CallbackManager } from "../../engine/Utilities/CallbackManager";

export enum EToastKind {
  Error = 'Error',
  Success = 'Success',
  Warning = 'Warning',
  Info = 'Info'
}

export interface IToastOptions {
  kind: EToastKind;
  timeoutMs: number | null;
}

export interface IToastOptionsOpt {
  kind?: EToastKind;
  timeoutMs?: number | null;
}

export type TToastNotification = (message: string, options: IToastOptions) => void;

@injectable()
export class ToastNotificationsController {
  private readonly _messageBus = new CallbackManager<TToastNotification>();

  public subscribe(callback: TToastNotification): CallbackSubscription {
    return this._messageBus.subscribe(callback);
  }

  public publish(message: string, options?: IToastOptionsOpt): void {
    this._messageBus.invoke(message, {
      kind: options?.kind ?? EToastKind.Info,
      timeoutMs: options?.timeoutMs !== undefined ? options.timeoutMs : 5000
    });
  }
}
